'use client';

import { ReactNode } from "react";

export function ExhibitionsDetailScrollSnapFrame({ children }: { children: ReactNode}) {
    return (
        <div className="relative">
            {children}
        </div>
    )
}

export function ExhibitionsDetailHeroFrame({ children }: { children: ReactNode}) {
    return (
        <div className="relative w-full">
            {children}
        </div>
    )
}

export function ExhibitionsDetailSectionFrame({ children }: { children: ReactNode }) {
    return (
        <div className="relative w-full">
            {children}
        </div>
    )
}
